/** Import Node Modules */
import React, { Component } from "react";
import {
  change as ReduxFormChange,
  destroy,
  formValueSelector
} from "redux-form";
/** Import Redux Library */
import { connect } from "react-redux";
/** Import Local Components */
import ReactPaginate from "react-paginate";
import PlaylistArchiveTable from "../modules/playlistArchiveTable";
import { Dialog } from "../../../core";

import {
  Resources as playlistResources,
  RemoveItemFromContentList,
  postArchivedItems,
  removeSingleArchivedPlaylist,
  unArchivePlaylists
} from "../../playlist/redux/playlistRedux";
import { Resources } from "../redux/archiveRedux";

class ArchivePlaylist extends Component {
  constructor(props) {
    super(props);
    this.perPageCount = 20;
    Resources.getArchivedPlaylist.url = `/playlists/archive?page=${1}&per_page=${
      this.perPageCount
    }`;
    this.props.Get(Resources.getArchivedPlaylist).then(() => {
      this.setState({
        isLoading: false
      });
    });
    this.archiveTableRefs = React.createRef();
    this.initialSortOrder = {
      name: { active: false, sortBy: "desc" },
      status: { active: false, sortBy: "desc" },
      created_at: { active: false, sortBy: "desc" },
      updated_at: { active: false, sortBy: "desc" }
    };
    this.state = {
      forcePage: undefined,
      sortOrder: this.initialSortOrder,
      isLoading: true,
      sortValue: { isSortable: false },
      deleteModal: {
        id: undefined,
        modal: false,
        body: "Are you sure you want to delete this content.",
        title: "Confirm Delete"
      }
    };
  }

  handleSort = name => {
    this.setState({ isLoading: true, forcePage: 0 });
    this.props.ReduxFormChange(
      "SelectedPlaylistOnArchive",
      "selectedPlaylist",
      []
    );
    this.archiveTableRefs.current.selectionContext.selected = [];
    this.archiveTableRefs.current.setState({});
    this.setState(
      prevState => ({
        sortOrder: {
          ...this.initialSortOrder,
          [name]: {
            active: true,
            sortBy: prevState.sortOrder[name].sortBy === "desc" ? "asc" : "desc"
          }
        },
        sortValue: {
          name,
          active: true,
          sortBy: prevState.sortOrder[name].sortBy === "desc" ? "asc" : "desc",
          isSortable: true
        }
      }),
      () => {
        const { getArchivedPlaylist } = Resources;
        getArchivedPlaylist.url = `/playlists/archive/?sort=${name}&sort_by=${
          this.state.sortOrder[name].sortBy
        }&page=${1}&per_page=${this.perPageCount}`;
        this.props
          .Get(Resources.getArchivedPlaylist)
          .then(() => this.setState({ isLoading: false }));
      }
    );
  };

  handleDeleteConfirmation = (id, name) => {
    const { deleteModal } = this.state;
    deleteModal.modal = true;
    deleteModal.id = id;
    deleteModal.body = (
      <span>
        <small>Are you sure you want to delete </small>
        <strong>{name}</strong>?
      </span>
    );

    this.setState({ deleteModal });
  };

  handleUnArchiveItem = id => {
    const { unArchivePlaylist } = Resources;
    unArchivePlaylist.body = unArchivePlaylists({ filteredPlaylistId: [id] });
    this.props
      .Put(unArchivePlaylist)
      .then(() => {
        this.props.Get(Resources.getArchivedPlaylist).then(result => {
          if (result.status === 200) {
            return (
              this.props.archivePlaylists.length === 0 &&
              this.handlePageClick(this.props.meta, true)
            );
          }
        });
      })
      .then(() =>
        this.props.ReduxFormChange(
          "SelectedPlaylistOnArchive",
          "selectedPlaylist",
          []
        )
      );
  };

  handleUnArchivePlaylists = () => {
    const { unArchivePlaylist } = Resources;
    const filteredPlaylistId = this.props.selectedPlaylist.map(item => item.id);
    unArchivePlaylist.body = unArchivePlaylists({ filteredPlaylistId });
    this.props
      .Put(unArchivePlaylist)
      .then(() => {
        this.props.Get(Resources.getArchivedPlaylist).then(result => {
          if (result.status === 200) {
            return (
              this.props.archivePlaylists.length === 0 &&
              this.handlePageClick(this.props.meta, true)
            );
          }
        });
      })
      .then(() =>
        this.props.ReduxFormChange(
          "SelectedPlaylistOnArchive",
          "selectedPlaylist",
          []
        )
      )
      .then(() => {
        this.archiveTableRefs.current.selectionContext.selected = [];
        this.archiveTableRefs.current.setState({});
      })
      .then
      // () => console.error(this.props.archivePlaylists.length)
      // this.props.archivePlaylists.length === 0 && this.handlePageClick(this.props.meta, true)
      ();
  };

  handleDelete = () => {
    const { deleteModal } = this.state;
    const filteredPlaylistId = this.props.selectedPlaylist.map(item => item.id);
    const { removeBulkPlaylist } = playlistResources;
    if (deleteModal.id) {
      removeBulkPlaylist.body = removeSingleArchivedPlaylist(deleteModal.id);
    } else {
      removeBulkPlaylist.body = postArchivedItems({ filteredPlaylistId });
    }
    this.props
      .Put(removeBulkPlaylist)
      .then(() => {
        this.props.Get(Resources.getArchivedPlaylist).then(result => {
          if (result.status === 200) {
            return (
              this.props.archivePlaylists.length === 0 &&
              this.handlePageClick(this.props.meta, true)
            );
          }
        });
        deleteModal.modal = false;
        deleteModal.id = undefined;
        this.setState({
          deleteModal
        });
      })
      .then(() =>
        this.props.ReduxFormChange(
          "SelectedPlaylistOnArchive",
          "selectedPlaylist",
          []
        )
      )
      .then(() => {
        this.archiveTableRefs.current.selectionContext.selected = [];
        this.archiveTableRefs.current.setState({});
      });
  };

  handlePageClick = (data, moveToPrevious = false) => {
    window.scrollTo(0, 0);
    this.setState({ isLoading: true });
    const { getArchivedPlaylist } = Resources;
    if (moveToPrevious) {
      getArchivedPlaylist.url = `/playlists/archive?page=${data.page -
        1}&per_page=${this.perPageCount}`;
      this.props.Get(getArchivedPlaylist).then(() => {
        this.setState({ forcePage: data.page - 2, isLoading: false });
      });
    } else {
      this.setState({ forcePage: undefined });
      this.setState({ isLoading: true });
      const { selected } = data;
      if (this.state.sortValue.isSortable) {
        getArchivedPlaylist.url = `/playlists/archive?sort=${
          this.state.sortValue.name
        }&sort_by=${this.state.sortValue.sortBy}&page=${selected +
          1}&per_page=${this.perPageCount}`;
      } else {
        getArchivedPlaylist.url = `/playlists/archive?page=${selected +
          1}&per_page=${this.perPageCount}`;
      }
      this.props
        .Get(getArchivedPlaylist)
        .then(() => this.setState({ forcePage: selected, isLoading: false }));
    }
  };

  toggleModel = flag => {
    const { deleteModal } = this.state;
    deleteModal.modal = flag;
    this.setState({ deleteModal });
  };

  render() {
    const { deleteModal } = this.state;
    return (
      <div>
        <Dialog
          externalControl
          showHandler={false}
          modal={deleteModal.modal}
          body={deleteModal.body}
          title={deleteModal.title}
          toggleModel={this.toggleModel}
          primaryMethod={this.handleDelete}
        />
        <PlaylistArchiveTable
          {...this.props}
          forwardRef={this.archiveTableRefs}
          handleSort={this.handleSort}
          sortOrder={this.state.sortOrder}
          handleDelete={this.handleDeleteConfirmation}
          isLoading={this.state.isLoading}
          playlistList={this.props.archivePlaylists}
          handleUnArchiveItem={this.handleUnArchiveItem}
          // following props used for bulk archive and delete
          handleUnArchivePlaylists={this.handleUnArchivePlaylists}
          handleDeleteConfirmation={this.handleDeleteConfirmation}
          selectedContentsLen={this.props.selectedPlaylist.length}
        />
        {!this.state.isLoading &&
          this.props.archivePlaylists &&
          this.props.archivePlaylists.length > 0 && (
            <div className="contentSectionPagination clearfix">
              <ReactPaginate
                pageCount={this.props.meta ? this.props.meta.totalPages : 0}
                pageRangeDisplayed={3}
                onPageChange={this.handlePageClick}
                marginPagesDisplayed={2}
                activeClassName="active"
                containerClassName="pagination"
                subContainerClassName="pages pagination"
                previousLabel="<"
                forcePage={this.state.forcePage}
                nextLabel=">"
                breakLabel="..."
                breakClassName="break-me"
                disabledClassName="paginationDisable"
              />
            </div>
          )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { list, status, loading, hasError, meta } = state.archivePlaylists;
  const selector = formValueSelector("SelectedPlaylistOnArchive");

  return {
    archivePlaylists: list !== undefined ? list : [],
    selectedPlaylist: selector(state, "selectedPlaylist") || [],
    loading,
    hasError,
    meta,
    status
  };
}

export default connect(
  mapStateToProps,
  { ReduxFormChange, destroy, RemoveItemFromContentList }
)(ArchivePlaylist);
